<template>
  <el-dialog :append-to-body="appendToBody" @close="closeSelector" :model-value="props.visible" width="1000px"
    class="tq-version-department-selector" :destroy-on-close="isDestroy">
    <template #title>
      <div class="title flex justify-between">
        <div>{{ title }}</div>
        <tq-version-search-input :query-path="personSearchPath" ref="versionSearchInputRef" :extra-params="personQuery"
          :multiple="multiple" :selected-list="selectList" @change="onInputChange" :type="1"
          :org-version-tree-data="treeList" />
        <span />
      </div>
    </template>
    <div class="department-opearte-pannel">
      <el-row class="inner-wrap">
        <el-col :span="8" class="org-tree__wrap beauty-scroll--small">
          <div class="selected-form-wrap">
            <el-form :model="versionSelectedForm" ref="versionSelectedFormInstance"
              class="version-selected-form el-form--item__flex" :inline="false">
              <el-form-item label="版本" prop="version">
                <el-select v-model="versionSelectedForm.version" class="fill" plceholder="请选择" clearable filterable
                  @change="handleVersionChange">
                  <el-option v-for="item in versionOpts" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="tree-wrap" v-loading="treeLoading" element-loading-text="加载中...">
            <el-tree :props="propsTree" accordion highlight-current node-key="id" @node-click="nodeHandleClick"
              ref="tree" :data="treeList" />
          </div>
        </el-col>
        <el-col :span="8" class="dept-list__wrap beauty-scroll--small">
          <div class="checkall-wrap" v-if="multiple">
            <el-checkbox class="el-checkbox--big__size" v-model="checkedAll" @change="checkAllHandleClick">
              <span class="font-bold">全选</span>
            </el-checkbox>
          </div>
          <div class="checkboxs-wrap">
            <tq-version-choose-box v-for="(item, index) in dataList" :key="index" :item="item"
              @change="checkOnChange($event, index)" :multiple="multiple" />
          </div>
        </el-col>
        <el-col :span="8" class="result-preview__wrap">
          <div class="right-header flex justify-between items-center">
            <span class="has-selected">已选择（{{ selectList.length
              }}）</span>
            <el-button size="small" type="text" @click="clearHandleClick">
              清空
            </el-button>
          </div>
          <div class="selected-depts__wrap">
            <div class="selected-dept-list" v-for="(item, index) in selectList" :key="index">
              <tq-version-tag-box closeable @close="closeTagBox($event, index)" class="seleted-dept-item">
                <div class="overflow-hidden-text">
                  <el-tooltip effect="dark" :content="item.name" placement="top" :open-delay="500">
                    <span class="dept-name">{{ item.code
                      }}-{{ item.name }}</span>
                  </el-tooltip>
                  <div class="bt-wrap">
                    <div class="status" :class="statusCls(item.status)">
                      {{ OrgStatusZh[item.status] }}
                    </div>
                    <div class="time">
                      <span>{{
                        dayjs(item.startDate).format('YYYY/MM/DD')
                      }}</span>
                      <span>-</span>
                      <span>{{
                        dayjs(item.endDate).format('YYYY/MM/DD')
                      }}</span>
                    </div>
                  </div>
                </div>
              </tq-version-tag-box>
            </div>
          </div>
          <div class="opeartion-btns flex justify-end items-center">
            <el-button @click="closeSelector" size="small">
              取消
            </el-button>
            <el-button type="primary" @click="submit" :disabled="selectList.length === 0" size="small">
              确定
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script lang="ts" setup>
import * as orgApi from "./apis"
import tqVersionSearchInput from './components/tqVersionSearchInput'
import tqVersionChooseBox from './components/tqVersionChooseBox'
import tqVersionTagBox from './components/tqVersionTagBox'
import { MessageCode, OrgStatus, OrgStatusZh, ReleaseStatus } from "./utils/enums"
// @ts-ignore
import * as dayjs from 'dayjs'
import { ref, reactive, watch } from "vue"
defineOptions({
  name: "TqVersionDepartmentSelector",
});
const emit = defineEmits(["close", 'update:visible', 'confirm'])
const props = defineProps({
  // 标题
  title: {
    type: String,
    default: "行政组织"
  },
  // 是否可见
  visible: {
    type: Boolean,
    default: false
  },
  // appendToBody
  appendToBody: {
    type: Boolean,
    default: false
  },
  personSearchPath: {
    type: String,
    default: "/org/classify/selDepartAndPersons"
  },
  // 默认的部门departmentId
  defaultDepartmentId: {
    type: String,
    default: ""
  },
  // 是否多选
  multiple: {
    type: Boolean,
    default: false
  },
  // 已选中数据
  selectedList: {
    type: Array,
    default: () => {
      return []
    }
  },
  isDestroy: {
    type: Boolean,
    default: false
  },
  versionLimit: {
    type: [String, Number],
    default: ''
  }
})
const personQuery = ref({
  classifyCode: "1",
  deptPageNo: 1,
  deptPageSize: 10,
  isAdministrative: "1",
  keyword: "",
  personPageNo: 1,
  personPageSize: 10
})
const dataList = ref<any>([])
const selectList = ref<any[]>([])
const height = ref<number>(0)
const propsTree = ref<Record<string, string>>({
  label: "deptName",
  children: "deptList",
  isLeaf: "leaf"
})
const treeList = ref<any[]>([])
const checkedAll = ref<boolean>(false)
const versionOpts = ref<any[]>([])
const versionSelectedForm = reactive({
  version: ''
})

const statusCls = (status: number | string) => {
  switch (`${status}`) {
    case "0":
      return ['status-expired']
    case "1":
      return ['status-in-effect']
    case "2":
      return ['status-to-be-effect']
    default:
      return null
  }
}
const treeLoading = ref<boolean>(false)
watch(
  () => dataList.value,
  newArr => {
    checkedAll.value = newArr && newArr.length > 0 && newArr.every((item: any) => item.checked)
  },
  { deep: true }
)
watch(
  () => props.visible,
  async newVal => {
    if (newVal) {
      selectList.value = JSON.parse(JSON.stringify(selectList.value))
      dataList.value.map((item:any) => {
        if (selectList.value.filter(childItem => childItem.code === item.code).length !== 0) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      if (props.isDestroy) {
        personQuery.value = {
          classifyCode: "1",
          deptPageNo: 1,
          deptPageSize: 10,
          isAdministrative: "1",
          keyword: "",
          personPageNo: 1,
          personPageSize: 10
        } // 查询条件
        await getAllOrganizationVersionSvc()
        await getVersionAllDeptsSvc()
      }
    }
  }
)
// methods 
const getAllOrganizationVersionSvc = async () => {
  try {
    const res = await orgApi.getAllOrganizationVersion({})
    if (res && res.msgCode == MessageCode.Success) {
      let responseData = res.responseData
      // 默认选中生效中版本
      const versionInEffect = responseData.find((item: any) => {
        return item.status == OrgStatus.InEffect
      })
      let list = []
      switch (`${props.versionLimit}`) {
        case "":
        case "0":
          // 生效中
          list = responseData.filter((item: any) => item.status == OrgStatus.InEffect)
          if (versionInEffect) {
            versionSelectedForm.version = versionInEffect.id
          }
          break
        case "1":
          // 生效中 待生效
          let isPublishShow = (item: any) => `${item.releaseStatus}` === ReleaseStatus.Published
          list = responseData.filter((item: any) => [OrgStatus.InEffect].includes(item.status) || ([OrgStatus.ToBeEffect].includes(item.status) && isPublishShow(item)))
          if (list && list.length) {
            if (versionInEffect) {
              versionSelectedForm.version = versionInEffect.id
            } else {
              versionSelectedForm.version = list[0].id
            }
          }
          break
        case "2":
          // 生效中 已失效
          list = responseData.filter((item: any) => [OrgStatus.InEffect, OrgStatus.Expired].includes(item.status))
          if (list && list.length) {
            if (versionInEffect) {
              versionSelectedForm.version = versionInEffect.id
            } else {
              versionSelectedForm.version = list[0].id
            }
          }
          break
        default:
          break
      }
      versionOpts.value = list.map((item: any) => {
        return {
          label: item.versionDesc,
          value: item.id
        }
      })
    }
  } catch (e) {
    console.log(e)
  }
}

const getVersionAllDeptsSvc = async () => {
  treeLoading.value = true
  try {
    // 版本切换的时候中间的所有部门可选项目
    dataList.value = []
    const res:any = await orgApi.getVersionAllDepts({
      classifyCode: 1,
      isAdministrative: 1,
      orgVersionId: versionSelectedForm.version,
      deptId: '',
      date: ''
    })
    if (res.msgCode === "100") {
      treeList.value = res.responseData[0].deptList
    }

    treeLoading.value = false
  } catch (e) {
    treeLoading.value = false
  }
}

const versionSearchInputRef = ref()
const handleVersionChange = () => {
  getVersionAllDeptsSvc()
  if (versionSearchInputRef.value && versionSearchInputRef.value.resetDataList) {
    versionSearchInputRef.value.resetDataList()
  }
}

const onInputChange = (e: Event | boolean, value: any) => {
  // 多选
  if (props.multiple) {
    if (e) {
      if (!selectList.value.some(item => item.code === value.code)) {
        selectList.value.push(value)
      }

      dataList.value.forEach((item:any) => {
        if (item.code === value.code) {
          item.checked = true
        }
      })
    } else {
      selectList.value.map((item, index) => {
        if (item.code === value.code) {
          selectList.value.splice(index, 1)
        }
      })
      dataList.value.forEach((item:any) => {
        if (item.code === value.code) {
          item.checked = false
        }
      })
    }
  } else {
    // 单选
    selectList.value = []
    dataList.value.forEach((item:any) => {
      if (item.code === value.code) {
        item.checked = true
      } else {
        item.checked = false
      }
    })
    selectList.value.push(value)
  }
}

const checkAllHandleClick = (isCheckAll: any) => {
  dataList.value.forEach((item: any) => {
    onInputChange(isCheckAll, item)
  })

}

const checkOnChange = (e: Event | boolean, key: number | string) => {
  // 多选
  if (props.multiple) {
    dataList.value[key].checked = e
    if (e) {
      selectList.value.push(dataList.value[key])
    } else {
      selectList.value.map((item, index) => {
        if (item.code === dataList.value[key].code) {
          selectList.value.splice(index, 1)
        }
      })
    }
  } else {
    selectList.value = []
    dataList.value.map((item:any, index:number) => {
      if (key === index) {
        item.checked = true
        selectList.value.push(item)
      } else {
        item.checked = false
      }
    })
  }
}

const closeSelector = () => {
  selectList.value = []
  emit('update:visible', false)
}

const nodeHandleClick = (data:any) => {
  const list: any[] = []
  if (data.deptList.length === 0) {
    list.push({
      ...data,
      checked: selectList.value.filter(e => e.code === data.departCode).length !== 0,
      name: data.deptName,
      code: data.departCode,
      desc: typeSwicth(data.departLevel)
    })
  } else {
    list.push({
      ...data,
      checked: selectList.value.filter(e => e.code === data.departCode).length !== 0,
      name: data.deptName,
      code: data.departCode,
      desc: typeSwicth(data.departLevel)
    })
    data.deptList.map((item:any) => {
      list.push({
        ...item,
        checked: selectList.value.filter(e => e.code === item.departCode).length !== 0,
        name: item.deptName,
        code: item.departCode,
        desc: typeSwicth(item.departLevel)
      })
    })
  }
  dataList.value = list
}
const closeTagBox = (e: Event | boolean, index: number) => {
  dataList.value.map((item:any) => {
    if (item.code === selectList.value[index].code) {
      item.checked = false
    }
  })
  selectList.value.splice(index, 1)
}

const submit = () => {
  emit("confirm", selectList.value)
}

const clearHandleClick = () => {
  selectList.value = []
  dataList.value.map((item:any) => {
    item.checked = false
  })
}

const typeSwicth = (value: string) => {
  switch (value) {
    case "01":
      return "集团组织"
    case "02":
      return "公司组织"
    case "03":
      return "一级部门"
    case "04":
      return "二级部门"
    case "05":
      return "三级部门"
    case "06":
      return "四级部门"
    case "07":
      return "五级部门"
    case "08":
      return "六级部门"
    case "09":
      return "七级部门"
  }
}
</script>